/**
 * M3X.WORKSPACE F.9 — Module rail keyboard shortcuts ⌘1-⌘7.
 *
 * Per spec §0.5. Honors input/textarea/contenteditable focus so
 * shortcuts don't fire while the user is typing. F.10 adds the
 * intra-Rail-2 J/K/H/L/Enter shortcuts.
 */

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { RAIL_1_MODULES } from "./Rail1";


export function useModuleShortcuts(): void {
  const navigate = useNavigate();

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      // Modifier must be ⌘ (Mac) or Ctrl (Windows/Linux)
      const mod = e.metaKey || e.ctrlKey;
      if (!mod) return;
      if (e.altKey || e.shiftKey) return;

      // Don't intercept inside inputs
      const target = e.target as HTMLElement | null;
      if (
        target &&
        (target.tagName === "INPUT" ||
          target.tagName === "TEXTAREA" ||
          target.isContentEditable)
      ) {
        return;
      }

      // ⌘1 → module 0, ⌘2 → module 1, ..., ⌘7 → module 6
      const idx = parseInt(e.key) - 1;
      if (idx >= 0 && idx < RAIL_1_MODULES.length) {
        e.preventDefault();
        navigate(RAIL_1_MODULES[idx].pathPrefix);
      }
    }
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [navigate]);
}
